import { useLocale } from '@/utils/LocaleUtil'
import { getBasePath } from '@/utils/sitemap/base'

export const useCanonicalUrl = (path: string) => {
  const { locale } = useLocale()

  return `${getBasePath(locale)}${path}`
}
